<template>
  <div class="users-page scrollable">
    <div class="page-header">
      <h1>Users List</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>Users List</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="top-bar">
      <div class="count-user">
      </div>
      <div class="filter-user">
        <el-button type="primary" @click="addNewUser" v-show="this.group">Add new user</el-button>
      </div>
    </div>

    <div class="top-bar">
      <div class="count-user">
        Show
        <el-select
            v-model="countUser"
            @change="changeCount"
            placeholder=" "
        >
          <el-option
              v-for="item in countUserOptions"
              :key="item.value"
              :label="item.value"
              :value="item.value"
          >
          </el-option>
        </el-select>
        entries
      </div>
      <div class="filter-user">
        <el-input
            @change="searchUser"
            placeholder="Search"
            v-model="filterUser"
            prefix-icon="el-icon-search"
        ></el-input>
      </div>
    </div>

    <el-tabs type="border-card" v-model="selectedTab" @tab-click="loadTabContent">
      <el-tab-pane label="Customers" group="user" name="Customers">
        <user-table-list page-label="user"
                         :count-user="countUser"
                         :filter-user="filterUser"
                         :filter-props="filterBlock['user']"  />
      </el-tab-pane>
      <el-tab-pane label="Cold DataBase" group="cold"  :lazy="true" name="Cold">
        <cold-table-list page-label="cold"
                         :count-user="countUser"
                         :filter-user="filterUser"
                         :filter-props="filterBlock['cold']" />
      </el-tab-pane>
      <el-tab-pane label="Subscribers" group="subscribers" :lazy="true" name="Subscribers">
        <subscribers-table-list page-label="subscribers"
                                :count-user="countUser"
                                :filter-user="filterUser"
                                :filter-props="filterBlock['social']" />
      </el-tab-pane>
      <el-tab-pane v-bind="UsersPageData.props.tabs.panes.trashedUsers.origin">
        <trashed-users-table-list page-label="subscribers"
                                :count-user="countUser"
                                :filter-user="filterUser"
                                :filter-props="filterBlock['social']" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HeaderSortTitle from '../../../../components/UsersList/HeaderSortTitle.vue'
import UserTableList from "../../../../components/UsersList/UserTableList.vue";
import ColdTableList from "../../../../components/UsersList/ColdTableList.vue";
import SubscribersTableList  from "../../../../components/UsersList/SubscribersTableList.vue";
import TrashedUsersTableList from "../../../../components/UsersList/TrashedUsersTableList.vue";
import UsersPageData from "./data";

export default {
  name: 'UsersPage',
  components: {
    HeaderSortTitle,
    UserTableList,
    ColdTableList,
    SubscribersTableList,
    TrashedUsersTableList,
  },
  computed: {
    ...mapGetters({
      searchParams: 'users/searchParams',
      formatData: 'formatData/getFormates',
      selectedTabFromVuex: 'usersPageFilter/getSelectedTab',
      countUserFromVuex: 'usersPageFilter/getCountUser',
    }),
    selectedTab: {
        get() {
            return this.selectedTabFromVuex;
        },
        set(value) {
            this.$store.dispatch('usersPageFilter/updateSelectedTab', value);
        },
    },
    countUser: {
        get() {
            return this.countUserFromVuex;
        },
        set(value) {
            this.$store.dispatch('usersPageFilter/updateCountUser', value);
        },
    },
  },
  data () {
    return {
      search: '',
      chosenPage: 1,
      group: 1,
      statusSelect: '',
      filterBlock:{},
      filterUser: '',
      countUserOptions: [
        {value: 10},
        {value: 25},
        {value: 50},
        {value: 100},
      ],
      UsersPageData,
    }
  },
  methods: {
    filterChange(filter) {
      this.filterBlock = filter
      this.updateUserList()
    },
    searchUser (e) {
      this.filterUser = e
      this.updateUserList()
    },
    changeCount (e) {
      this.countUser = e
      this.updateUserList()
    },
    addNewUser () {
      this.$router.push({name: 'user-create'})
    },
    loadTabContent (tab, event) {
      this.$store.dispatch('usersPageFilter/updateChosenPage', 1);
      const TRASHED_USER_TAB_NAME = UsersPageData.props.tabs.panes.trashedUsers.origin.name;
      switch (tab.name) {
        case TRASHED_USER_TAB_NAME:
          this.$store.dispatch('users/getTrashedUsers')
          break;
        default:
          this.updateUserList();
      }
    },
    updateUserList() {
      this.$store.dispatch('usersPageFilter/updateChosenPage', 1);
      let params = 'sort='
      if (this.sortBy) {
        for (let itm in this.sortBy) {
          if (this.sortBy[itm] === 1) {
            params = `${params}${itm},`
          } else if (this.sortBy[itm] === -1) {
            params = `${params}-${itm},`
          }
        }
      }

      if (params === 'sort=') {
        params = ''
      }

      params = `${params}&page=${this.chosenPage}`

      if (this.countUser) {
        params = `${params}&per_page=${this.countUser}`
      }

      if (this.filterUser.length) {
        params = `${params}&filter=${encodeURIComponent(this.filterUser)}`
      }

      if (this.selectedFilter) {
        this.filterBlock = this.selectedFilter;
        this.handleFilterChange(this.filterBlock);
      }

      if (typeof this.filterBlock != 'undefined' && Object.keys(this.filterBlock).length) {
        Object.entries(this.filterBlock).forEach(([key, value]) => {
          if(value.length==0){
            return;
          }
          params = `${params}&${key}=`+JSON.stringify(value)
        });
      }
      this.$store.dispatch('users/getUsers', params)
    },
  },
  created () {
    if(!this.getFormates){
      this.$store.dispatch('formatData/getFormatData')
    }
  },
}
</script>

<style scoped lang="scss">
th {
  .cell {
    .pointer {
      cursor: pointer;
    }
  }
}

.count-user {
  width: 170px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > div {
    margin: 0 5px;
  }
}

.filter-user {
}
</style>
